import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Planning/filtrarPlanning`, method: 'POST', body: values, token: token})
}
